<template>
  <div class="Sidebar">
        <!-- <el-drawer
            title="我是标题"
            :visible.sync="drawer"
            :modal="false"
            size="420px"
            :wrapperClosable="false"
            :with-header="false">
             -->
            <div class="position-btn" @click="sidebarPositon">
                <img src="../../../../common/images/catalog/icon-right.png" alt="right" v-if="drawer === false">
                <img src="../../../../common/images/catalog/icon-left.png" alt="right" v-else>
            </div>
            <!-- 操作按钮 -->
            <section class="sidebar-header" @click="goto">
                <div class="img">
                    <img v-lazy="studyData.coverurl" alt="studyData.subject">
                </div>
                <div class="text">
                    <p class="title">{{studyData.subject}}</p>
                    <p><span class="money"><template v-if="studyData.saleprice == 0"> 免费</template><template v-else> ¥ {{studyData.saleprice}}</template></span> <span class="participate">{{studyData.joincount}}参与</span></p>
                </div>
            </section>

            <el-tabs @tab-click="handleClick" v-model="direction" :class="{'navNumber': studyData.coursetype == 2}">
                <el-tab-pane v-if="studyData.coursetype  == 2" name="catalog">
                    <span slot="label">
                        <i class="icon-1"></i>目录</span>
                    <Catalog :studyData='studyData' ref="catalog"></Catalog>
                </el-tab-pane>
                <!-- 系列课才展示目录 -->
                <el-tab-pane name="discuss">
                    <span slot="label">
                        <i class="icon-2"></i>讨论</span>
                    <Discuss :studyData='studyData' ref="discuss"></Discuss>
                </el-tab-pane>
                <el-tab-pane name="note">
                    <span slot="label">
                        <i class="icon-3"></i>笔记</span>
                    <Note :studyData='studyData' ref='note'></Note>
                </el-tab-pane>
            </el-tabs>

        <!-- </el-drawer> -->
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Discuss from './Discuss'
import Catalog from './Catalog'
import Note from './Note'
import $ from 'jquery'

export default {
    name: 'Sidebar',
    props: ['studyData'],   // 取得课程详情
    data() {
        return {
            drawer: false, //抽屉状态
            direction: 'catalog'
        }
    },
    mounted() {
        let inval = setInterval(() => {
            if (this.studyData.coursetype) {
                if (this.studyData.coursetype == 1) {
                    this.direction = 'discuss'
                }
                clearInterval(inval)
            }
           
        },1)
        // if (this.studyData.coursetype == 1) {
        //     this.$nextTick(() => {
        //         this.direction = 'discuss'
        //     })
        // }
       // 第一次进来展开
      this.sidebarPositon()
    },
    methods: {
        goto() {
            this.$router.push({name: 'CourseDetails', query: {cid: this.$route.query.courseid}})
        },
        handleClick() {
            this.$refs.note.scrollTop()
            // this.$refs.catolog.scrollTop =  0
            // console.log(this.$refs.catolog.scrollTop)
        },
        sidebarPositon() {  // 抽屉控制
            if (this.drawer === false) {
                this.drawer = true
                $('.Study .Sidebar').addClass('active')
                $('.Study .study-main').addClass('active')
                $('.Study .content').addClass('active')
                $('.Study .StudyMsg').addClass('active')
            } else {
                this.drawer = false
                $('.Study .Sidebar').removeClass('active')
                $('.Study .study-main').removeClass('active')
                $('.Study .content').removeClass('active')
                $('.Study .StudyMsg').removeClass('active')
            }
        },
         ...mapActions([
            'setLoading'
        ]),
         ...mapGetters(['user']),
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Discuss,
        Catalog,
        Note,
    }
    
}
</script>

<style lang="scss" type="text/scss" scope> 
.Sidebar {
    position: fixed;
    z-index: 111;
    top: 0;
    // right: 0;
    right: -420px;
    width: 420px;
    height: 100%;
    background: #fff;
    transition: all .5s;
    -webkit-transition: all .5s;
    -ms-transition: all .5s;
    -o-transition: all .5s;
    -moz-transition: all .5s;

    &.active {
        right: 0;
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        -moz-transition: all .5s;
    }
    

    .position-btn {
        position: absolute;
        cursor: pointer;
        top: 63px;
        left: -26px;
        
        img {
            width: 26px;
            height: 32px;
            // transform: rotate(180deg)
        }
    }

    .el-tabs {
        height: calc(100% - 124px);
        background: #F8F8F8;

        &.navNumber {
            .el-tabs__nav {
                .el-tabs__item {
                    width: calc(100% / 3);
                    text-align: center;
                }
            }
        }
        .el-tabs__content {
            height: 100%;
            overflow: auto;
        }
        .el-tabs__nav-wrap {
            background: #fff
        }
        .el-tabs__nav {
            width: 100%;
            .el-tabs__item {
                width: calc(100% / 2);
                text-align: center;
            }
        }
        .is-active {
            img {
                // display: none;
                
                &.active {
                    // display: inline-block
                }
            }
        }
    }

    .icon-2,
    .icon-3,
    .icon-1 {
        display: inline-block;
        margin-right: 5px;
        width: 14px;
        height: 14px;
        transform: translateY(2px);
        -webkit-transform: translateY(2px);
        -ms-transform: translateY(2px);
        -moz-transform: translateY(2px);
        -o-transform: translateY(2px);
    }
    .icon-1 {
        background: url('../../../../common/images/catalog/icon-catalog-1-false.png') no-repeat 100%;
        background-size: 14px;
    }
    .icon-2 {
        background: url('../../../../common/images/catalog/icon-catalog-2-false.png') no-repeat 100%;
        background-size: 14px;
    }
    .icon-3 {
        background: url('../../../../common/images/catalog/icon-catalog-3-false.png') no-repeat 100%;
        background-size: 14px;
    }

    .el-tabs__item:hover,
    .is-active {
        .icon-1 {
            background: url('../../../../common/images/catalog/icon-catalog-1.png') no-repeat 100%;
            background-size: 14px;
        }
        .icon-2 {
            background: url('../../../../common/images/catalog/icon-catalog-2.png') no-repeat 100%;
            background-size: 14px;
        }
        .icon-3 {
            background: url('../../../../common/images/catalog/icon-catalog-3.png') no-repeat 100%;
            background-size: 14px;
        }
    }
    
    .el-drawer {
        box-shadow: none;

        &>div:focus,
        &:focus {
            outline: none !important;
        }
    }

    .sidebar-header {
        padding: 20px 10px 20px 20px;
        overflow: hidden;

        div {
            float: left;

            &.text {
                margin-left: 10px;
                width: calc(100% - 158px)
            }
        }
        img {
            width:148px;
            height:84px;
            background:rgba(216,216,216,1);
            border-radius:4px;
        }
        .title {
            margin-bottom: 10px;
            font-size:14px;
            line-height: 20px;
            min-height: 40px;
            font-weight:500;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .money {
            font-size:14px;
            color: #FF4747
        }
        .participate {
            margin-left: 12px;
            font-size: 12px;
            color: #999;
        }
    }
}
</style>